import $ from "jquery"

class Tabs {

	constructor() {
		this.selectedFilters = '';
		this.magicLineLeftPos = 0;
		this.noResulstsMsg = $(".tabla-module .hx-noresults").val();
		this.previousEvents = $(".previous-events");
		this.eventList = $("#tab-events .tab-pane");
		this.tabEvents = $("#tab-events");
		this.loader = $("#tab-events .lds-loader");

		this.sceneFilter = [];
		this.sceneFilter['desktop'] = $(".scene-filter.desktop li");
		this.sceneFilter['mobile'] = $(".scene-filter.mobile");
		this.dateFilter = $(".date-filter li");

		this.selectedScenes = $(".filter--scenes");

		if (this.tabEvents.length) {
			// If no date is selected, target the first
			if (!this.dateFilter.parent().find(".selected").length) {
				this.dateFilter.parent().find("li:eq(0)").addClass('selected');
			}

			this.filterEvents();
			this.magicLine();
			this.bindEvents();
		}
	}

	bindEvents() {
		var self = this;

		this.previousEvents.on('click', function (e) {
			e.preventDefault();
			$(this).fadeOut();
			self.tabEvents.removeClass('show-previous').addClass('show-previous');
		});

		self.sceneFilter['desktop'].on('click', function (e) {
			e.preventDefault();

			self.sceneFilter['desktop'].each(function (i) {
				$(this).removeClass('selected');
			});

			$(this).addClass('selected');

			self.selectedScenes.val($(this).data('filter'));

			self.filterEvents();
		});

		self.sceneFilter['mobile'].on('change', function (e) {
			self.selectedScenes.val($(this).children("option:selected").val());

			self.filterEvents();
		});

		this.dateFilter.on('click', function (e) {
			e.preventDefault();

			self.dateFilter.each(function (i) {
				$(this).removeClass('selected');
			});

			$(this).addClass('selected');

			self.filterEvents();
		});
	}

	filterEvents(category) {
		var self = this;

		// Round to nearest full number to preserve cache
		let current_date = new Date();

		let c_minutes = current_date.getMinutes();
		c_minutes = c_minutes - (c_minutes % 10);

		let c_date = current_date.getFullYear();
		c_date += String(current_date.getMonth());
		c_date += String(current_date.getDate());

		let postVars = {
			action: 'hx_get_events',
			nonce: ajax.nonce,
			cache: String(c_date + c_minutes),
			'date': self.dateFilter.parent().find(".selected").data('filter'),
			'scenes': self.selectedScenes.val()
		};

		self.loader.fadeIn();

		if (self.eventList.data('requestRunning')) {
			return;
		}

		self.eventList.data('requestRunning', true).fadeOut().html('');

		// Initialize loading animation
		// TODO:

		$.ajax({
			beforeSend: xhr => {
				xhr.setRequestHeader('X-WP-Nonce', ajax.nonce)
			},
			url: ajax.url,
			method: 'GET',
			data: postVars,
			dataType: 'json',
		}).done(response => {
			var html = '';

			if (response.event_html) {
				$.each(response.event_html, function (key, data) {
					html += data;
				});
			} else {
				html = '<h3 class="text-center center-block font-weight-normal op--4 my-5">' + self.noResulstsMsg + '</h3>';
			}

			self.eventList.data('requestRunning', false).fadeIn().html(html);

			// Show old posts?
			self.previousEvents.fadeOut();

			$('.tab-pane .event-block .inner').each(function () {
				if ($(this).hasClass('has-passed')) {
					self.previousEvents.fadeIn();
				}
			});

			self.loader.fadeOut();
		});
	}

	magicLine() {
		var self = this;

		if (!$(".nav.nav-tabs li").length) return false;

		var $el, leftPos, newWidth,
			$mainNav = $(".nav.nav-tabs");

		$mainNav.append("<li id='ac-line'></li>");
		var $magicLine = $("#ac-line");

		var $selected = $(".nav.nav-tabs li.selected a");

		if ($selected.length) {
			$magicLine.stop().animate({
				left: $selected.position().left,
				width: $selected.parent().width()
			});
		}

		$magicLine
			.width($(".selected").width())
			.css("left", 0) // $(".selected a").position().left
			.data("origLeft", $magicLine.position().left)
			.data("origWidth", $magicLine.width());

		$(".nav.nav-tabs li a").hover(function () {
			$el = $(this);
			leftPos = $el.position().left;
			newWidth = $el.parent().width();
			$magicLine.stop().animate({
				left: leftPos,
				width: newWidth
			});
		}, function () {
			var $selected = $(".nav.nav-tabs li.selected a");

			if ($selected.length) {
				var animateSettings = {
					left: $selected.position().left,
					width: $selected.parent().width()
				}
			}

			$magicLine.stop().animate(animateSettings);
		});
	}
}

export default Tabs;
